module.exports = __webpack_public_path__ + "static/media/forecast-file-upload.d658560e.svg";